import React, { useState, useContext, useEffect } from "react";
import { AppSettings } from "./../../config/app-settings.js";
import { Icon } from "@iconify/react";
import { Tooltip } from "bootstrap";

function ThemePanel() {
  const { appThemePanelToggled, setAppThemePanelToggled } = useContext(AppSettings);

  // theme-gray-500 es el default
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("appTheme") === "theme-default";
  });

  const toggleAppThemePanel = (event) => {
    event.preventDefault();
    const state =
      appThemePanelToggled === true || appThemePanelToggled === "true"
        ? false
        : true;
    setAppThemePanelToggled(state);
    localStorage.setItem("appThemePanelToggled", state);
  };

  const setAppTheme = (theme) => {
    // Eliminar clases anteriores
    document.body.classList.remove("theme-default", "theme-gray-500");
    document.documentElement.classList.remove("theme-default", "theme-gray-500");

    // Agregar nueva clase
    document.body.classList.add(theme);
    document.documentElement.classList.add(theme);

    // Guardar en localStorage
    localStorage.setItem("appTheme", theme);
    document.dispatchEvent(new Event("theme-reload"));
  };

  const toggleDarkMode = () => {
    const newTheme = darkMode ? "theme-gray-500" : "theme-default";
    setAppTheme(newTheme);
    setDarkMode(!darkMode);
  };

  useEffect(() => {
    // Inicializar tooltips
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => new Tooltip(e));

    const savedTheme = localStorage.getItem("appTheme");

    // Limpiar clases
    document.documentElement.classList.remove("theme-default", "theme-gray-500");
    document.body.classList.remove("theme-default", "theme-gray-500");

    // Aplicar tema guardado o default
    if (savedTheme) {
      document.documentElement.classList.add(savedTheme);
      document.body.classList.add(savedTheme);
      setDarkMode(savedTheme === "theme-default"); // oscuro si es theme-default
    } else {
      // Si no hay tema guardado, aplicar theme-gray-500 como default
      document.documentElement.classList.add("theme-gray-500");
      document.body.classList.add("theme-gray-500");
      localStorage.setItem("appTheme", "theme-gray-500");
      setDarkMode(false);
    }

    // Cargar estado del panel
    if (localStorage.getItem("appThemePanelToggled") === "true") {
      setAppThemePanelToggled(true);
    }
  }, [setAppThemePanelToggled]);

  return (
    <div className={"app-theme-panel" + (appThemePanelToggled ? " active" : "")}>
      <div className="app-theme-panel-container">
        <a
          href="#/"
          onClick={toggleAppThemePanel}
          className="app-theme-toggle-btn"
        >
          <Icon icon="ph:gear-duotone" />
        </a>
        <div className="app-theme-panel-content">
          <div className="fs-10px fw-semibold text-white mb-2">MODO OSCURO</div>
          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="darkModeSwitch"
              checked={darkMode}
              onChange={toggleDarkMode}
            />
            <label
              className="form-check-label text-white"
              htmlFor="darkModeSwitch"
            >
              {darkMode ? "Activado" : "Desactivado"}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThemePanel;